// @flow
import React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import { images, strings } from '../../../../../config';
import AddressRow from "../../../../Address/AddressRow/AddressRow";
import CurrentRequestSelectors from "../../../../../Store/Ducks/CurrentRequest/selectors";
import CurrentRequestOperations from "../../../../../Store/Ducks/CurrentRequest/operations";
import FloatingAddressContainer from "../../../../FloatingAddressContainer/FloatingAddressContainer";
import {DestAddressLabel, OriginAddressLabel, ProposalBoxAddressLabel} from "../../../../Address/AddressesStyle";
import Screens from "../../../../../Store/Views/screens";

type ConnectedProps = {
    originAddress: string,
    destAddress: string,
    onClickOriginLabel: () => void,
    onClickDestLabel: () => void,
    showSelectDest: boolean,
};

const FreeSelectionTop = (props: ConnectedProps) => {
    const topRow = {
        children: (
            <AddressRow pinImageMain={{src: images.request_origin_pin, alt: "origin_pin"}}
                        addressTitleLabel={
                            <OriginAddressLabel>
                                {strings.origin_address_label}
                            </OriginAddressLabel>}
                        addressField={
                            <ProposalBoxAddressLabel>
                                {props.originAddress || ""}
                            </ProposalBoxAddressLabel>}
                        pinImageSecondary={{src: images.edit_origin, alt: "edit_origin"}}
            />),
        onClick: props.onClickOriginLabel,
    };
    const bottomRow = props.showSelectDest ? {
        children: (
            (<AddressRow pinImageMain={{src: images.request_dest_pin, alt: "dest_pin"}}
                         addressTitleLabel={
                             <DestAddressLabel>
                                 {strings.dest_address_label}
                             </DestAddressLabel>}
                         addressField={
                             <ProposalBoxAddressLabel>
                                 {props.destAddress || ""}
                             </ProposalBoxAddressLabel>}
                         pinImageSecondary={{src: images.edit_dest, alt: "edit_dest"}}
            />)

        ),
        onClick: props.onClickDestLabel,
    } : undefined;
    return (<FloatingAddressContainer topRow={topRow} bottomRow={bottomRow}/>);

};

const mapStateToProps = state => {
    return {
        originAddress: CurrentRequestSelectors.getOriginAddress(state),
        destAddress: CurrentRequestSelectors.getDestAddress(state),
        showSelectDest: Screens.shouldShowSelectDest(state),
    };
};

const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators(
        {
            onClickOriginLabel: CurrentRequestOperations.clickOriginLabel,
            onClickDestLabel: CurrentRequestOperations.clickDestLabel
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapActionsToProps)(FreeSelectionTop);



// WEBPACK FOOTER //
// ./src/Components/Screen/RideRequest/FreeSelection/FreeSelectionTop/FreeSelectionTop.js